// The Venue Studio, full screen (__root.tsx renders 'venue-studio' without the sidebar or top bar).
// A flat file route: it outranks the legacy $ splat, while /venues/:id stays on that switch.
// ?event=<id> opens it in event scope: that event's seat state on the venue. `event` is the console's
// GLOBAL EVENT LENS (__root.tsx retains it across every navigation), so the Studio's event scope is
// that lens: opening a seat map from an event sets it, and leaving keeps it, as everywhere else.
import React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { VenueStudio } from '../modules/venues/studio/VenueStudio';
import { pathForRoute } from '../lib/router';

export const Route = createFileRoute('/venues/$id/studio')({
  // ?from=event: opened from the event page, so the back arrow returns there, not to the venue.
  // ?replay=<policy>: replaying a simulated sale run on the event's Seating → Simulator.
  // ?ba={productId, quantity, wheelchair, profile, pick}: open on the Seating tab's Best Available preview.
  validateSearch: (search: Record<string, unknown>): { event?: string; from?: 'event'; replay?: string; ba?: Record<string, unknown> } => ({
    ...(typeof search.event === 'string' && search.event ? { event: search.event } : {}),
    ...(search.from === 'event' ? { from: 'event' as const } : {}),
    ...(typeof search.replay === 'string' && search.replay ? { replay: search.replay } : {}),
    ...(search.ba && typeof search.ba === 'object' ? { ba: search.ba as Record<string, unknown> } : {}),
  }),
  component: VenueStudioRoute,
});

function VenueStudioRoute() {
  const { id } = Route.useParams();
  const { event, from, replay, ba } = Route.useSearch();
  const navigate = useNavigate();
  return (
    <VenueStudio
      venueId={id}
      eventId={event ?? null}
      replay={replay ?? null}
      initialBA={ba ?? null}
      onReplayChange={(policy) => navigate({ to: '/venues/$id/studio', params: { id }, search: (prev: any) => ({ ...prev, replay: policy || undefined }), replace: true })}
      onOpenSimulator={() => event && navigate({ to: '/events/$id', params: { id: event }, search: { tab: 'seating', view: 'simulator' } as any })}
      onEventChange={(eventId) => navigate({ to: '/venues/$id/studio', params: { id }, search: eventId ? { event: eventId, ...(from ? { from } : {}) } : {}, replace: true })}
      onBack={() => (from === 'event' && event
        ? navigate({ to: '/events/$id', params: { id: event } })
        : navigate({ to: pathForRoute('venue-detail', { id }) as any }))}
    />
  );
}
